import { useState, useEffect } from 'react';
import { DeviceType, ScreenSize, AdaptiveScale } from '../types';

const useScreenSize = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState<ScreenSize>({
    width: window.innerWidth,
    height: window.innerHeight,
    deviceType: 'desktop'
  });
  
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      let deviceType: DeviceType = 'desktop';
      if (width <= 768) deviceType = 'mobile';
      else if (width <= 1024) deviceType = 'tablet';
      else if (width <= 1366) deviceType = 'laptop';
      else if (width >= 2560) deviceType = 'large-screen';
      else if (width >= 3840) deviceType = 'ultra-wide';
      
      setScreenSize({ width, height, deviceType });
    };
    
    window.addEventListener('resize', handleResize);
    handleResize(); // 初始化
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return screenSize;
};

export const useAdaptiveScale = (): AdaptiveScale => {
  const { width, deviceType } = useScreenSize();
  
  const getScaleFactor = (): number => {
    const baseWidth = 1920; // 设计稿基准宽度
    let scaleFactor = width / baseWidth;
    
    // 设备特定调整
    switch (deviceType) {
      case 'tablet':
        scaleFactor = Math.min(scaleFactor, 0.8);
        break;
      case 'large-screen':
        scaleFactor = Math.min(scaleFactor, 1.5);
        break;
      case 'ultra-wide':
        scaleFactor = Math.min(scaleFactor, 2);
        break;
      default:
        scaleFactor = Math.max(0.5, Math.min(scaleFactor, 2));
    }
    
    return scaleFactor;
  };
  
  return {
    scaleFactor: getScaleFactor(),
    deviceType,
    screenWidth: width
  };
};